
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { useIsMobile } from '@/hooks/use-mobile';

interface SearchTradingAccountsProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
}

export function SearchTradingAccounts({ 
  searchQuery, 
  onSearchChange 
}: SearchTradingAccountsProps) {
  const isMobile = useIsMobile();
  
  return (
    <div className="relative">
      <Search className={`absolute left-3 top-1/2 ${isMobile ? 'h-3.5 w-3.5' : 'h-4 w-4'} -translate-y-1/2 text-muted-foreground`} />
      <Input
        placeholder={isMobile ? "Search API keys..." : "Search by API name, client ID or account number..."}
        className="pl-10 text-sm"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
  );
}
